export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/valuSVG.ef9e9190.svg","height":21,"width":54,"blurWidth":0,"blurHeight":0};